export const getLanguage = () => getInitialI18n().lang || 'en';
export const getTranslations = () => getInitialI18n().localeData;

function getInitialI18n() {
  return window.__INITIAL_I18N__ || {};
}



// WEBPACK FOOTER //
// ./app/services/i18n-utils.js